import { render, staticRenderFns } from "./SlideSharedLinkMenu.vue?vue&type=template&id=66d2b661&scoped=true"
import script from "./SlideSharedLinkMenu.vue?vue&type=script&lang=ts"
export * from "./SlideSharedLinkMenu.vue?vue&type=script&lang=ts"
import style0 from "./SlideSharedLinkMenu.vue?vue&type=style&index=0&id=66d2b661&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d2b661",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d2b661')) {
      api.createRecord('66d2b661', component.options)
    } else {
      api.reload('66d2b661', component.options)
    }
    module.hot.accept("./SlideSharedLinkMenu.vue?vue&type=template&id=66d2b661&scoped=true", function () {
      api.rerender('66d2b661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/SlideSharedLinkMenu.vue"
export default component.exports